
frappe.provide("client_portal.fenris_canopy_lookup");

import CanopyConnect from  "./canopy-connect.js";
window.CanopyConnect = CanopyConnect;
import "./base_lookup";
import "./fenris";
import "./canopy";
